/** WhatsApp campaigns: approved marketing templates to opted-in customers. Conventions: see `common.ts`. */
const whatsapp: Record<string, string> = {
  title: 'Campaigns',
  subtitle:
    'Send an approved marketing template to the customers who opted in on WhatsApp, from your own number.',
  new_campaign: 'New campaign',
  see_plans: 'See plans',
  not_in_plan: 'Campaigns are not included in your plan. Your earlier campaigns are kept.',
  own_number_notice:
    'Campaigns go out from the WhatsApp number connected to this store — there is no shared platform number. Connect your number first.',
  connect_number: 'Connect WhatsApp',
  no_templates:
    'Campaigns need an approved MARKETING template. Draft one under Templates and submit it to Meta first.',
  go_to_templates: 'Open Templates',

  'form.title': 'New campaign',
  'form.description':
    'Saved as a draft. Nothing goes out until you send it, only opted-in customers are messaged, and the send paces itself to your number’s messaging limit.',
  'form.name': 'Campaign name',
  'form.name_placeholder': 'Diwali launch',
  'form.template': 'Template',
  'form.template_choose': 'Choose an approved marketing template',
  'form.variables': 'Fill in the template',
  'form.customer_name_hint': 'Left blank, each customer’s own name is used.',
  'form.audience': 'Audience',
  'form.audience_count': '{count} customers will receive it',
  'form.audience_empty': 'Nobody in this audience has opted in yet.',
  'form.preview': 'Preview',
  'form.save_draft': 'Save draft',

  'audience.ALL': 'Everyone who opted in',
  'audience.NEW': 'New this month',
  'audience.REPEAT': 'Repeat customers (2+ orders)',
  'audience.HIGH_VALUE': 'High-value customers',
  'audience.INACTIVE': 'Lapsed (no order in 60 days)',

  'status.DRAFT': 'draft',
  'status.SCHEDULED': 'scheduled',
  'status.SENDING': 'sending',
  'status.SENT': 'sent',
  'status.PAUSED': 'paused',
  'status.CANCELLED': 'cancelled',
  'status.FAILED': 'failed',

  'list.empty_title': 'No campaigns yet',
  'list.empty_description':
    'Announce a launch, a festival offer, or a restock to your opted-in customers with an approved template.',
  'list.draft_first': 'Draft your first campaign',
  'list.template': 'Template: {name}',
  'list.counts': '{sent} sent · {delivered} delivered · {read} read · {failed} failed',
  'list.recipients': '{total} recipients',
  'list.scheduled_for': 'Scheduled for {when}',
  'list.send': 'Send now',
  'list.schedule': 'Schedule',
  'list.schedule_for': 'Send at',
  'list.confirm_schedule': 'Confirm',
  'list.cancel': 'Cancel',
  'list.resume': 'Resume',
  'list.delete': 'Delete draft',
  'list.delete_confirm': 'Delete this draft?',
  'list.paused_quality':
    'Paused: your number’s quality rating is red. Improve it in WhatsApp Manager, then resume.',
};

export default whatsapp;
